import React from 'react';
import styles from '../styles/components/Stepper.module.css';

export interface StepperData {
  labels: string[];
  step: number;
  onCompletion: (newSelection: number) => void;
}

const Stepper: React.FC<StepperData> = data => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {data.labels.map((label, index) => (
          <div
            key={index}
            className={styles.stepContainer}
            onClick={() => {
              if (index !== data.step) {
                data.onCompletion(index);
              }
            }}
          >
            <span
              className={
                index === data.step
                  ? styles.stepSelectedElement
                  : styles.stepElement
              }
            >
              {label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
export default Stepper;
